import React, { useState } from 'react';
import './AssignmentResult.css';

function AssignmentResult({ assignment, isLoading, error, saveStatus, assignmentId, isAuthenticated }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    // Strip HTML tags when copying to clipboard for plain text
    // Also remove dashes and bullet points
    const textOnly = assignment
      .replace(/<[^>]*>/g, '') // Remove HTML tags
      .replace(/&nbsp;/g, ' ')
      .replace(/^[-•]\s+/gm, '') // Remove leading dashes and bullet points
      .replace(/\n[-•]\s+/g, '\n'); // Remove dashes and bullet points at line start
    navigator.clipboard.writeText(textOnly);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDownload = () => {
    // Strip HTML tags when downloading for plain text
    // Also remove dashes and bullet points
    const textOnly = assignment
      .replace(/<[^>]*>/g, '') // Remove HTML tags
      .replace(/&nbsp;/g, ' ')
      .replace(/^[-•]\s+/gm, '') // Remove leading dashes and bullet points
      .replace(/\n[-•]\s+/g, '\n'); // Remove dashes and bullet points at line start
    const blob = new Blob([textOnly], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'task.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  if (isLoading) {
    return (
      <div className="assignment-result-container">
        <div className="loading-section">
          <div className="loading-spinner"></div>
          <h2>Generating Your Task</h2>
          <p>This may take a few moments. We're creating a personalized, plagiarism-free content for you.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="assignment-result-container">
        <div className="error-section">
          <h2>Error Generating Task</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="assignment-result-container">
      <div className="result-header">
        <h2>Your Personalized Task</h2>
        <p className="result-subtitle">
          This content has been generated based on your selected opinion and fact-checked sources. 
          It's been humanized to Outsmart AI Detectors.
        </p>
        {isAuthenticated && saveStatus === 'saved' && (
          <div className="save-status success">
            ✓ Task saved to your account
          </div>
        )}
        {isAuthenticated && saveStatus === 'saving' && (
          <div className="save-status saving">
            ⏳ Saving task...
          </div>
        )}
        {isAuthenticated && saveStatus === 'error' && (
          <div className="save-status error">
            ⚠️ Failed to save task. You can still copy it.
          </div>
        )}
        {!isAuthenticated && (
          <div className="save-status info">
            💡 <a href="#login" onClick={(e) => { e.preventDefault(); alert('Please sign in to save your tasks.'); }}>Sign in</a> to save this task to your account
          </div>
        )}
      </div>

      <div className="result-actions">
        <button 
          className="action-btn copy-btn"
          onClick={handleCopy}
        >
          {copied ? '✓ Copied!' : '📋 Copy to Clipboard'}
        </button>
        <button 
          className="action-btn download-btn"
          onClick={handleDownload}
        >
          📥 Download as TXT
        </button>
      </div>

      <div className="assignment-content">
        <div 
          className="assignment-text"
          dangerouslySetInnerHTML={{ 
            __html: assignment
              .replace(/^[-•]\s+/gm, '') // Remove leading dashes and bullet points
              .replace(/\n[-•]\s+/g, '\n') // Remove dashes and bullet points at line start
              .split(/\n\n+/) // Split by double newlines (paragraphs)
              .map(para => {
                // Remove any remaining leading/trailing dashes
                para = para.trim().replace(/^[-•]\s+/, '').replace(/\s+[-•]$/, '');
                // If paragraph contains HTML, preserve it
                if (/<span style=/.test(para)) {
                  return `<p>${para.replace(/\n/g, '<br />')}</p>`;
                }
                // Plain text paragraph
                return `<p>${para.replace(/\n/g, '<br />')}</p>`;
              })
              .join('')
          }}
        />
      </div>

      <div className="result-footer">
        <div className="info-badge">
          <span className="badge-icon">✓</span>
          <span>Plagiarism-free and humanized</span>
        </div>
        <div className="info-badge">
          <span className="badge-icon">✓</span>
          <span>Fact-checked sources included</span>
        </div>
        <div className="info-badge">
          <span className="badge-icon">✓</span>
          <span>Optimized for natural, human-like writing</span>
        </div>
      </div>
    </div>
  );
}

export default AssignmentResult;

